import { render } from "./COIActionBarMarkParcelLoss.vue?vue&type=template&id=5cfc5cf8"
import script from "./COIActionBarMarkParcelLoss.vue?vue&type=script&lang=js"
export * from "./COIActionBarMarkParcelLoss.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__